import React from 'react';
import ReactDOM from 'react-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from '../src/redux/store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastProvider } from './toast/toastContext';
import CustomToaster from './toast/customToaster';
import { ErrorBoundary } from 'react-error-boundary';
import FallBack from './pages/fallback';
import { BannerProvider } from './banner/bannerContext';
import { ThemeModeProvider } from './contexts/themeContext';
import { AssistantProvider } from './contexts/assistantContext';

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeModeProvider>
          <ToastProvider>
            <ErrorBoundary FallbackComponent={FallBack}>
              <BannerProvider>
                <AssistantProvider>
                  <App />
                </AssistantProvider>
              </BannerProvider>
            </ErrorBoundary>
            <CustomToaster />
          </ToastProvider>
        </ThemeModeProvider>
      </PersistGate>
    </Provider>
  </Router>,
  document.getElementById('root')
);

reportWebVitals();
